import React from 'react'

import Input from '../../atoms/Input/Input'
import Text from '../../atoms/Text/Text'
import { emptyFunction } from 'app/app/common/utils'

type CheckboxMoleculeProps = React.ComponentProps<typeof Input> & {
  id: string
  label?: string
  onChecked?: (event: React.MouseEvent<HTMLDivElement>, checked: boolean) => void
  className?: string
  checked?: boolean
  checkboxSize?: 'small' | 'medium' | 'large'
}

const Checkbox: React.FC<CheckboxMoleculeProps> = ({
  id,
  label,
  onChecked,
  className = 'checkbox',
  checked = false,
  checkboxSize = 'small',
  ...props
}: CheckboxMoleculeProps) => (
  <div className={className} onClick={event => !props.disabled && onChecked && onChecked(event, !checked)}>
    <Input
      id={id}
      type="checkbox"
      className={`checkbox__input checkbox--size-${checkboxSize}`}
      aria-label="Checkbox Input"
      checked={checked}
      onChange={emptyFunction}
      role="checkbox"
      {...props}
    />
    {label && (
      <Text
        id={`${id}-Label`}
        as="label"
        className={`checkbox-label ${props.disabled ? 'text-disabled-text cursor-not-allowed!' : 'text-black cursor-pointer'}`}
        role="label"
      >
        {label}
      </Text>
    )}
  </div>
)

export default Checkbox
